"use strict";
(function (global) {


  /**
  * Редактор для компоненты slick-грида, для реквизита типа "Дробное число"
  * @class WebAccess.components.dataViews.gridPlugins._editors.FloatEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @since 5.2.0.1300 
  */
  global.FloatEditor = global.StringEditor.extend({
    init: function (args) {
      var me = this;
      me.type = 'float';
      me._super(args);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отрисовка реквизита, при активации редактора на ячейке грида
    * @method WebAccess.components.dataViews.gridPlugins._editors.FloatEditor#render
    * @since 5.2.0.1300     
    */
    render: function () {
      var me = this;
      me._super();
      var currentColumn = me._getColumn();
      if (!currentColumn.isDisabled()) {
        var opt = $.extend({}, $.fn.autoNumeric.defaults);
        if (me._column.precision) {
          opt = { mDec: '' + me._column.precision, aPad: true }
        }
        me._jInput.autoNumeric('init', opt);
      }
      return me.renderState;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значение реквизита для рендеринга редактора.
    * @private
    */
    _getValueForRender: function () {
      return this._value;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение значение из реквизита
    * @method WebAccess.components.dataViews.gridPlugins._editors.FloatEditor#serializeValue
    * @since 5.2.0.1300     
    */
    serializeValue: function () {
      var me = this;
      var currentColumn = me._getColumn();
      var control = me._getWrapper();
      var value = control.getValue();
      if (!currentColumn.isDisabled()) {
        //Шамов А.: Что бы сработало форматирование дробного числа в плагине autoNumeric.
        me._jInput.autoNumeric('format');
      }
      return { value: value, displayValue: me._jInput.val() };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Очистка поля
    * @method WebAccess.components.dataViews.gridPlugins._editors.IntegerEditor#destroy
    * @since 5.2.0.9100     
    */
    destroy: function () {
      var me = this;
      var autoNumeric = me._jInput.data('autoNumeric');
      if (typeof autoNumeric === 'object') {
        // Для того, чтобы обязательно отработал focusout
        // у контрола, установив значение в реквизит
        me._jInput.trigger('focusout.autoNumeric');
      }
      me._super();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

})(window.WA.components.dataViews.gridPlugins._editors)